const collapsibleMenuBtn = document.querySelector('.collapsible-menu-btn');
const collapsibleMenuContent = document.querySelector('.collapsible-menu-content');
const menuCloseBtn = document.querySelector('.menu-close-btn');
const siteContent = document.querySelector('.main-menu-site-content');
const menu = document.querySelector(".collapsible-main-menu");
const menuItems = menu.querySelectorAll(".collapsible-menu-list li");
const contactItems = menu.querySelectorAll(".contact-option li");
const footerBlocks = document.querySelectorAll(".collapsible-menu-footer > div");
const contactBtn = document.querySelector('.header-contact-btn');
const contactForm = document.querySelector('.header-collapsible-contact-form');
const contactFormCloseBtn = document.querySelector('.header-collapsible-contact-form-close-btn');

//contact form toggle
document.addEventListener('DOMContentLoaded', function() { 
  const formTimeline = gsap.timeline({ 
    paused: true, 
    defaults: { ease: "power3.out" }
  });
 
  const formTopBtn = contactForm.querySelector('.form-top-btn');
  const formTitle = contactForm.querySelector('.form-title');
  const formContainer = contactForm.querySelector('.form-input-container');

  const formBtn = contactForm.querySelector('.form-btn');
  const formFooter = contactForm.querySelector('.form-footer-content');

  formTimeline
    .fromTo(contactForm, 
      { x: "100%", opacity: 0 }, 
      { x: "0%", opacity: 1, duration: 0.8, ease: "power4.out" }
    )
    .from(formTopBtn, {
      x: 50,
      opacity: 0,
      duration: 0.3,
      ease: "back.out(1.2)"
    }, "-=0.3")
    .from(formTitle, {
      x: 30,
      opacity: 0,
      duration: 0.3,
      ease: "power4.out"
    }, "-=0.3")
    .from(formContainer, {
    x: 40,
      opacity: 0,
      duration: 0.3,
      ease: "back.out(1.2)"
    }, "-=0.3")
    .from(formBtn, {
      scale: 0.5,
      opacity: 0,
      duration: 0.3,
      ease: "back.out(1.2)"
    }, "-=0.3")
    .from(formFooter, {
      x: 40,
      opacity: 0,
      duration: 0.3,
      ease: "power3.out",
    }, "-=0.3")
  const toggleForm = (e) => {
    e.preventDefault();
    if (contactForm.classList.contains('active')) {
      formTimeline.reverse();
      contactForm.classList.remove('active');
      document.body.classList.remove('has-contact-form-open');
      document.querySelector('.main-header').style.paddingBlock = '24px';
    } else {
      formTimeline.play();
      contactForm.classList.add('active');
      document.body.classList.add('has-contact-form-open');  
      document.querySelector('.main-header').style.paddingBlock = '0px';
    }
  };

  contactFormCloseBtn.addEventListener('click', toggleForm);
  contactBtn.querySelector('a').addEventListener('click', toggleForm);

  // Open contact form 
  const contactButtons = [
    '.bw-btn-marketing-service.header-collapsible-contact-form a',
    '.bw-btn-secondary.header-collapsible-contact-form a'
  ];
  
  contactButtons.forEach(selector => {
    const buttons = document.querySelectorAll(selector);
    buttons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        toggleForm(e);
      });
    });
  });
});




// Main menu 
const menuTimeline = gsap.timeline({ 
  paused: true, 
  defaults: { ease: 'power3.out' } 
});

// Menu open animation
menuTimeline
  .fromTo(menu, 
    { y: '100%', opacity: 0 }, 
    { y: '0%', opacity: 1, duration: 0.6, ease: 'power3.out' }
  )
  .from(menuCloseBtn, {
    y: -20,
    opacity: 0,
    scale: 0.5,
    duration: 0.3,
    ease: 'back.out(1.2)'
  }, '-=0.3')
  .from(siteContent, {
    y: 30,
    opacity: 0,
    duration: 0.4,
    ease: 'power2.out'
  }, '-=0.2')
  .from(menuItems, {
    y: 50,
    opacity: 0,
    stagger: 0.12,
    duration: 0.3,
    ease: 'back.out(1.2)'
  }, '-=0.5')
  .from(footerBlocks, {
    y: 40,
    opacity: 0,
    duration: 0.3,
    ease: 'power3.out',
    stagger: 0.2
  }, '-=0.3');

// Menu close animation
const closeMenu = () => {
  gsap.to(menu, {
    y: '100%',
    opacity: 0,
    duration: 0.4,
    ease: 'power3.in',
    onComplete: () => {
      collapsibleMenuContent.classList.remove('active');
      document.body.style.overflow = '';
      document.documentElement.style.overflow = '';
    }
  });
};

collapsibleMenuBtn.addEventListener('click', (e) => {
  e.preventDefault();
  collapsibleMenuContent.classList.add('active');
  menuTimeline.restart();
  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
});


// Close menu when clicking the close button
document.addEventListener('DOMContentLoaded', function() {
  const menuCloseBtn = document.querySelector('.menu-close-btn');
  if (menuCloseBtn) {
    menuCloseBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
    });
    
    // Add touch support
    menuCloseBtn.addEventListener('touchstart', (e) => {
      e.preventDefault();
      e.stopPropagation();
      closeMenu();
    }, { passive: false });
  }
});
